export enum ChatWorkStepState {
	Done = "done",
	Active = "active",
}

/** One thing the assistant did (or is doing) for a turn. `label` is already translated. */
export interface ChatWorkStep {
	id: string;
	label: string;
	state: ChatWorkStepState;
}

/** `Live` lists the steps while the assistant works; `Summary` folds a finished turn's steps behind one line. */
export enum ChatWorkStepsMode {
	Live = "live",
	Summary = "summary",
}

/** Matches the row being worked on inside a `Live` `ChatWorkSteps` list — for a leading figure that looks at it. */
export const CHAT_WORK_STEP_ACTIVE_SELECTOR = `li[data-state="${ChatWorkStepState.Active}"]`;
